import { useQuery } from "@tanstack/react-query";
import { createWebSignupAppHandoff } from "../../../api/user";

const parseDownloadContext = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    userId: params.get("userId")?.trim() ?? "",
    emailAddress: params.get("emailAddress")?.trim() ?? "",
  };
};

export const useEasyOnboardingDownloadLink = () => {
  const { userId, emailAddress } = parseDownloadContext();
  const shouldFetch = userId.length > 0 && emailAddress.length > 0;

  const { data, isError, isLoading } = useQuery({
    queryKey: ["webSignupAppHandoff", userId, emailAddress],
    queryFn: async () => {
      const response = await createWebSignupAppHandoff({ userId, emailAddress });
      return response.data;
    },
    enabled: shouldFetch,
    retry: 1,
    staleTime: Infinity,
  });

  const branchUrl = data?.branchUrl?.trim() ?? null;
  const useBranchLink = shouldFetch && !isError && Boolean(branchUrl);

  return {
    branchUrl,
    useBranchLink,
    isEasyOnboardingEnabled: shouldFetch,
    isLoading: shouldFetch && isLoading,
    isError,
  };
};
